export const REDIRECT_DELAY_MS = 2500;

export const BG_COLORS = [
  'var(--gradient_brand_1)',
  'var(--gradient_brand_3)',
  'var(--gradient_brand_4)',
  'var(--gradient_brand_5)',
  'var(--gradient_brand_7)',
  'var(--gradient_brand_9)',
  'var(--gradient_brand_10)',
];

export const STREAK_DAYS_KEY = 'current_streak_days';

export const STREAK_PAGE_LAST_VIEWED_KEY = 'streak_page_last_viewed_date';

export const RETURN_PATHNAME_KEY = 'return_pathname_key';
